import { ResourceConfigurationInterface } from '@cbsinteractive/avia-js';
import { IPromiseResolveGeneric } from 'library/ts/interfaces/IPromiseResolveGeneric';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';
import { AbstractDesktopResourceConfigBuilder } from 'tag/ts/tag/player/adapters/avia/resources/abstract/AbstractDesktopResourceConfigBuilder';

/**
 * @copyright © Paramount Streaming
 * @author  Zeeshan Ahmad
 * @description Builder class to create an instance of ResourceConfigurationInterface for playback via CID on Desktop
 */
export class DesktopCIDResourceConfigBuilder extends AbstractDesktopResourceConfigBuilder {

	constructor( argument: ITagAbstractClassArgument ) {
		super(
			{
				name: 'DesktopCIDResourceConfigBuilder',
				...argument
			} );
	}

	/**
	 * @description Returns filled resource configuration for playback via CID on Desktop
	 * @returns {Promise<IPromiseResolveGeneric & {resource: IResourceConfig}>}
	 */
	getResult(): Promise<IPromiseResolveGeneric & { resource: ResourceConfigurationInterface }> {
		return new Promise(
			( resolve, reject ) => {

				// get config prefilled with values for Desktop playback
				super.getResult().then(
					( data ) => {
						let resource: ResourceConfigurationInterface = data?.resource;

						// set values for CID playback
						resource = this.deepMergeResourceFromSmartTagParams( resource );

						resolve( { msg: 'Resource config', resource: resource } );
					}
				).catch(
					( error ) => {
						// Desktop CID resource config failed, provide minimal fallback for video playback
						this?.logger?.warn( 'Desktop CID resource config failed, using minimal configuration:', error );

						// Create minimal resource as fallback to ensure CID videos can still play
						const basicResource = window.avia.createResourceConfig();
						resolve( { msg: 'Resource config (minimal)', resource: basicResource } );
					}
				);
			}
		);
	}
}